import { useQueryMyWorkspaces } from '../../authz/authz.hooks';
import { userName } from '../../authz/gen/ai/h2o/user/v1/user_pb';
import { useUser } from '../../utils/hooks';
import { ownerFilterKey } from './components/WorkspacePageFilters/OwnerFilter';
import { useWorkspaceFiltering } from './hooks/useWorkspaceFiltering';
import { WorkspacesList } from './WorkspacesList';

export const MyWorkspaces = () => {
  const user = useUser();
  const { filters, searchText, handleSearchChange, aipFilter } = useWorkspaceFiltering();

  const workspacesQuery = useQueryMyWorkspaces(
    { filter: aipFilter },
    {
      enabled: !filters[ownerFilterKey]?.value,
      select: (data) => {
        const workspacesFromAllPages = data.pages.flatMap((page) => page.workspaces || []);
        return { pages: workspacesFromAllPages, pageParams: data.pageParams };
      },
    }
  );

  // Query for default workspace
  const defaultWorkspaceQuery = useQueryMyWorkspaces(
    { filter: `personal_workspace_subject = '${userName.compile({ user: user.id })}'` },
    {
      enabled: !user.isPublic,
      select: (data) => {
        const workspacesFromAllPages = data.pages.flatMap((page) => page.workspaces || []);
        return { pages: workspacesFromAllPages, pageParams: data.pageParams };
      },
    }
  );

  return (
    <WorkspacesList
      workspacesQuery={workspacesQuery}
      defaultWorkspaceQuery={defaultWorkspaceQuery}
      searchText={searchText}
      onSearchChange={handleSearchChange}
    />
  );
};
